import { render, staticRenderFns } from "./play-video.vue?vue&type=template&id=17ca9a85&scoped=true&"
import script from "./play-video.vue?vue&type=script&lang=js&"
export * from "./play-video.vue?vue&type=script&lang=js&"
import style0 from "./play-video.vue?vue&type=style&index=0&id=17ca9a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca9a85",
  null
  
)

export default component.exports